import * as _4 from 'lodash4';

interface IAuthenticationConfiguration {
  goToStateOnLogout: string;
  onLoggedInConfirmation?: string;
  onLoggedInFormSuccess?: string;
  automaticAccountSynchronization: boolean;
  authenticationApiPrefix: string;
  logoClass: string;
  defaultBackgroundImageUrl: string;
  metadata: {
    productName: string;
    showLockup: boolean;
    tagLine?: string;
    formalTitle: string;
    copyright: string;
    tagList: string[];
    footerLinks: any;
    termsOfUseModal: {
      enable: boolean;
      templateUrl: string;
    };
  };
}
interface IAuthenticationConfigurationProvider {
  configure: (userConfig: any) => AuthenticationConfiguration;
  read(): any;
}

export class AuthenticationConfiguration implements ng.IServiceProvider {
  private configuration: IAuthenticationConfiguration;

  configure(userConfig: any) {
    const currentYear = new Date().getFullYear();
    const DEFAULTS = {
      goToStateOnLogout: 'authentication',
      onLoggedInConfirmation: undefined,
      onLoggedInFormSuccess: undefined,
      automaticAccountSynchronization: true,
      authenticationApiPrefix: '',
      logoClass: '',
      defaultBackgroundImageUrl: '',
      metadata: {
        productName: 'EAB App',
        showLockup: true,
        tagLine: undefined,
        formalTitle: 'EAB Student Success Collaborative',
        copyright: `&copy; ${currentYear} EAB`,
        tagList: [],
        footerLinks: {},
        termsOfUseModal: {
          enable: false,
          templateUrl: 'capability-ng-authentication/src/views/authentication/tou_modal.html'
        }
      }
    };
    this.configuration = _4.merge({}, DEFAULTS, userConfig);
    return this;
  }

  activate(userConfig: any) {
    return this.configure(userConfig);
  }
  read() {
    return this.configuration;
  }

  public $get(): IAuthenticationConfigurationProvider {
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/configuration/authentication_configuration.ts